export default __webpack_public_path__ + "static/media/Beppe1.cb7523a9.jpg";